import { Component } from '@angular/core';

@Component({
  selector: 'app-rmd-tracker-servicer',
  templateUrl: './rmd-tracker-servicer.component.html',
  styleUrls: ['./rmd-tracker-servicer.component.css']
})
export class RmdTrackerServicerComponent {

}
